const ADMIN_PATH_MEMBERS = '/admin/members';
const ADMIN_PATH_CREATE_DEVICE = '/admin/create-device';
const ADMIN_PATH_ADD_USER = '/admin/add-user';
export { ADMIN_PATH_MEMBERS, ADMIN_PATH_CREATE_DEVICE, ADMIN_PATH_ADD_USER };
